import { useContext, useEffect, useState } from "react";
import { BaseModal } from "../../../../components/modal";
import { SelectCompaniesModalWrapper } from "./styled";
import { Context } from "../../../../context";
import { BaseSelect } from "../../../../components/form/select/styled";
import { BaseButton } from "../../../../components/button/styled";
import { Row } from "../../../../components/flex/styled";
import { BaseFieldSet } from "../../../../components/form/fieldset/styled";
import { Span } from "../../../../components/typography/styled";
import Cookies from "universal-cookie";
import { getCompanies } from "../../../../utils/apis/company/getCompanies";
import { useNavigate } from "react-router-dom";

export const SelectCompaniesModal = ({ height, width }) => {
  const cookies = new Cookies();
  const TOKEN = cookies.get("TOKEN");

  const navigate = useNavigate();
  const { isSelectCompaniesModalOpen, setIsSelectCompaniesModalOpen } =
    useContext(Context);

  const [matches, setMatches] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");

  useEffect(() => {
    if (!TOKEN) return;
    const fetchCompanies = async () => {
      try {
        const response = await getCompanies(TOKEN);
        return setCompanies(response);
      } catch (error) {
        console.error(error);
      }
    };
    fetchCompanies();
  }, [TOKEN]);

  const handleChange = (e) => {
    const { value } = e.target;
    setSelectedCompanyId(value);
  };

  const handleCloseModal = (e) => {
    e.preventDefault();
    document.body.style.overflow = "auto";
    document.body.style.pointerEvents = "auto";
    setIsSelectCompaniesModalOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    cookies.set("COMPANY_ID", selectedCompanyId, {
      path: "/",
      maxAge: 1000000,
    });
    document.body.style.overflow = "auto";
    document.body.style.pointerEvents = "auto";
    setIsSelectCompaniesModalOpen(false);
    return navigate("/dashboard");
  };

  useEffect(() => {
    const handleResize = () => {
      setMatches(window.screen.availWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <BaseModal
      open={isSelectCompaniesModalOpen}
      onClose={handleCloseModal}
      className={"select-companies-modal"}
      height={height || "auto"}
      width={matches ? "60%" : width || "40%"}
    >
      <SelectCompaniesModalWrapper>
        {/* Newton your code should go under this line */}
        <div>
          <legend>Select Company</legend>
        </div>
        <BaseFieldSet>
          <BaseSelect value={selectedCompanyId} onChange={handleChange}>
            <option value="" hidden>
              Select Company
            </option>
            {companies?.map((company, index) => (
              <option key={index} value={company.companyId}>
                {company.name}
              </option>
            ))}
          </BaseSelect>
        </BaseFieldSet>
        <Row className="action-buttons-row">
          <div>
            <BaseButton className="cancel-button" onClick={handleCloseModal}>
              <Span>Cancel</Span>
            </BaseButton>
          </div>
          <div>
            <BaseButton onClick={handleSubmit}>
              <Span>Ok</Span>
            </BaseButton>
          </div>
        </Row>
      </SelectCompaniesModalWrapper>
    </BaseModal>
  );
};
